import React, { memo, useState, useEffect } from 'react';

import Paper from '@mui/material/Paper';

import DraggableOverlay from '@common/components/draggable-overlay';

const PreviewExternalLinks = () => {
  const [linkSrc, setLinkSrc] = useState();
  const onClose = () => setLinkSrc(null);

  useEffect(() => {
    const handleClick = event => {
      if (event.target.closest('.renderedQuestionWrapper a:not(.cke_button)')) {
        event.preventDefault();

        const target = event.target.closest('a');
        setLinkSrc(target.href.replace(/^http:/i, 'https:'));

        // Set up monitor of the DOM node and automatically close this preview if the node no longer exists
        const observer = new MutationObserver(mutations => {
          // eslint-disable-next-line
          for (const mutation of mutations) {
            if (
              [...mutation.removedNodes].some(
                node => node === target || node.contains(target)
              )
            ) {
              observer.disconnect();
              onClose();
            }
          }
        });

        observer.observe(document.body, { childList: true, subtree: true });
      }
    };
    document.addEventListener('click', handleClick);

    return () => document.removeEventListener('click', handleClick);
  }, []);

  return (
    <DraggableOverlay
      visible={!!linkSrc}
      onClose={onClose}
      title="External Link Preview"
      style={{
        width: '60vw',
        maxWidth: 600,
        maxHeight: 480,
        top: 50,
        left: 50,
        zIndex: 2000
      }}
    >
      <Paper sx={{ width: '100%', height: '100%' }}>
        <iframe title="External Link Preview" src={linkSrc} referrerPolicy="no-referrer" />
      </Paper>
    </DraggableOverlay>
  );
};

export default memo(PreviewExternalLinks);
